module.exports = __webpack_public_path__ + "static/8-d68e12973920451ace079a84ba4c31e6.jpg";